const Margin = { marginTop: '1rem', gap: '1rem' };

export const styles = {
  Margin
};
